// extracted by mini-css-extract-plugin
module.exports = {"footerActions":"styles_footerActions__DsnYx","footerDisclaimer":"styles_footerDisclaimer__a2sMs","footer":"styles_footer__c5kvj"};